import React from 'react'
import './myCustomer.css'
import Navbar from '../MainComponent/navbar'
import SideNav from '../MainComponent/sideNav'
import CustomerInfo from './customerInfo'

export default function MyCustomer() {
  return (
    <div className='customerContainer'>
        <Navbar></Navbar>
        <SideNav active="myCustomer" />
        <div className='customerContent'>
            <CustomerInfo></CustomerInfo>
        </div>
    </div>
  )
}
